export default {
  SET_donation(state, payload) {
    state.donation = payload;
  }
};
